import { render, staticRenderFns } from "./LibraryReadingFormatEditor.vue?vue&type=template&id=64f8fd41&"
import script from "./LibraryReadingFormatEditor.vue?vue&type=script&lang=ts&"
export * from "./LibraryReadingFormatEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports